export enum SPLASH_SCREEN_EVENTS {
  SPLASH_SCREEN_SHOW = 'SPLASH_SCREEN_SHOW',
  SPLASH_SCREEN_HIDE = 'SPLASH_SCREEN_HIDE'
}